import React, { Component } from 'react'

import utils from '../utils'
const { priceFormat, FE } = utils

export default class RankItem extends Component {
  render(){
    let { goods, minPrice, pvId, index } = this.props,iconStyle,
    itemUrl = FE.Utils.getHref(`https://m.mall.autohome.com.cn/detail/${goods.itemId}-0-0.html#pvareaid=${pvId}`)
    switch(index){
      case 0:
        iconStyle = 'car-icon3 car-icon3--top1';
        break;
      case 1:
        iconStyle = 'car-icon3 car-icon3--top2';
        break;
      case 2:
        iconStyle = 'car-icon3 car-icon3--top3';
        break;
      default:
        iconStyle = 'car-icon3';
    }

    return(
      <a href={itemUrl} className='goods-item'>
        <div className='car-box'>
          <span className={iconStyle}></span>
          <img src={goods.picUrl} alt='' />
        </div>
        <div className='goods-info'>
          <p className={goods.carSourceType !== 0 && goods.carSourceType !== 3?'car-name car-name--isYX':'car-name'}>{goods.name}</p>
          <p className='car-ad'>{goods.slogan}</p>
          <div className='car-price-wrap'>
            <p className='car-price'><span>{priceFormat(minPrice)}</span>万</p>
          </div>
        </div>
      </a>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/RankItem.js